import { render, staticRenderFns } from "./task-center.vue?vue&type=template&id=70740f45&scoped=true&"
import script from "./task-center.vue?vue&type=script&lang=js&"
export * from "./task-center.vue?vue&type=script&lang=js&"
import style0 from "./task-center.vue?vue&type=style&index=0&id=70740f45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70740f45",
  null
  
)

export default component.exports